import {
  IconeCalendario,
  IconeComite,
  IconeHistorico,
  IconeMudanca,
  IconeNovo,
  IconePainel,
  IconeQuadro,
} from '../components/Icones'
import { TERMOS, TEXTOS } from './glossario'
import type { GrupoDeNavegacao } from './navegacao'

/**
 * Os grupos do módulo de mudanças, item a item. Importe sempre por `./navegacao`.
 *
 * O registro é um só, partido em arquivos pelo mesmo motivo que `Icones.tsx` e
 * `IconesDeNavegacao.tsx`: dezesseis itens com resumo e "o que vai ter" não cabem no teto de 200
 * linhas, e desligar a regra para uma lista longa é como o sistema anterior chegou a uma Blade de
 * 1119 linhas. O contrato (as interfaces) mora em `navegacao.ts` e chega aqui por `import type`,
 * que o compilador apaga — a dependência de execução aponta num sentido só.
 *
 * O que está em `oQueVaiTer` sai de `docs/plano-gmud-v2.md` (seções 4, 5 e 10). Não invente item:
 * esta é a página que o fiscal de contrato lê, e promessa que não está no plano vira cobrança.
 */

/** Grupo "Visão geral". */
export const VISAO_GERAL: GrupoDeNavegacao = {
  id: 'visao-geral',
  rotulo: 'Visão geral',
  itens: [
    {
      id: 'painel',
      rotulo: 'Painel',
      para: '/painel',
      icone: IconePainel,
      situacao: 'pronto',
      resumo: 'O que está esperando você e como andam as mudanças deste mês.',
    },
  ],
}

/** Grupo "Mudanças (GMUD)" — o módulo que já está no ar. */
export const MUDANCAS: GrupoDeNavegacao = {
  id: 'mudancas',
  rotulo: `Mudanças (${TERMOS.gmud.sigla})`,
  itens: [
    {
      id: 'gmuds',
      rotulo: TERMOS.gmud.rotuloPlural,
      para: '/gmuds',
      icone: IconeMudanca,
      situacao: 'pronto',
      resumo: TERMOS.gmud.ajuda,
    },
    {
      id: 'gmud-nova',
      rotulo: TEXTOS.abrirSolicitacao,
      para: '/gmuds/novo',
      icone: IconeNovo,
      permissao: 'GMUD_CRIAR',
      situacao: 'pronto',
      resumo: 'Abre a solicitação em rascunho; o plano vai sendo preenchido até dar para enviar ao comitê.',
    },
    {
      // O sistema anterior tem uma tela de kanban (`/admin/gmud/kanban`), mas ela mostra a tabela
      // de etapas — que lá nunca foi preenchida por ninguém e está vazia. Mandar o usuário para
      // uma tela vazia é pior do que dizer que a daqui ainda não existe, então não há link.
      id: 'gmud-quadro',
      rotulo: TEXTOS.quadro.titulo,
      para: '/gmuds/quadro',
      icone: IconeQuadro,
      situacao: 'pronto',
      resumo: 'As solicitações em colunas, por etapa, para ver de relance onde cada uma parou.',
    },
    {
      // Sem link para o sistema anterior porque lá não existe comitê: a reunião acontece no Teams
      // e a decisão vira um campo de texto na GMUD. É justamente o que esta tela substitui.
      id: 'cab',
      rotulo: TEXTOS.cab.titulo,
      para: '/cab',
      icone: IconeComite,
      organizacao: 'CONTRATANTE',
      situacao: 'pronto',
      resumo: TERMOS.cab.ajuda,
    },
    {
      id: 'cab-calendario',
      rotulo: TEXTOS.cab.calendario.titulo,
      para: '/cab/calendario',
      icone: IconeCalendario,
      situacao: 'pronto',
      resumo: TERMOS.janelaImplantacao.ajuda,
    },
    {
      // Aponta para a mesma lista com um recorte, e não para uma tela própria: assim o histórico
      // nunca diverge da lista — mesma tabela, mesmas colunas, mesmos filtros, mesma contagem.
      id: 'gmuds-historico',
      rotulo: TERMOS.historicoMigrado.rotulo,
      para: '/gmuds?origem=MIGRADO_V1',
      icone: IconeHistorico,
      situacao: 'pronto',
      resumo: 'As 1.027 solicitações trazidas do sistema antigo, só para consulta e pesquisa.',
    },
  ],
}
